import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ButtonComponent, MultiselectComponent, DatepickerComponent  } from "@ppl/ui";
import { NzColDirective, NzRowDirective } from "ng-zorro-antd/grid";
import { NzFormControlComponent, NzFormDirective, NzFormItemComponent } from "ng-zorro-antd/form";
import { NzOptionComponent, NzSelectComponent } from "ng-zorro-antd/select";
import { FormBuilder, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { CommonModule, NgIf } from "@angular/common";
import { AuthorizeDirective } from '../../../../../../shared/authorization/authorize.directive.';
import { NzAutocompleteModule } from 'ng-zorro-antd/auto-complete';
import { TimesheetService } from '../../../../../../services/timesheet.service';
import { LookupValueItem } from '../../../../../../interfaces/lookup.interface';
import { LookupService } from '../../../../../../services/lookup.service';
import { DateTimeFormatterService } from '../../../../../../shared/utils/date-time-formatter.service';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { UserService } from '../../../../../../services/user.service';

const fields = [
  { field: 'Timeframe', show: true, default: '30 days' },
  { field: 'status', show: true },
  { field: 'status', show: true },
  { field: 'consumer', show: true },
  { field: 'consumerPplId', show: true },
  { field: 'provider', show: true },
  { field: 'providerPplId', show: true },
  { field: 'chequeNumber', show: true },
  { field: 'payPeriod', show: false },
  { field: 'servicePeriod', show: false },
  { field: 'processStatusLkp', show: true },
  { field: 'serviceCode', show: true },
  { field: 'crmNumber', show: false }
];

@Component({
  selector: 'ppl-invoice-filter',
  standalone: true,
  imports: [
    ButtonComponent,
    NzColDirective,
    NzFormControlComponent,
    NzFormDirective,
    NzFormItemComponent,
    NzOptionComponent,
    NzRowDirective,
    NzSelectComponent,
    ReactiveFormsModule,
    NgIf,
    AuthorizeDirective,
    NzAutocompleteModule,
    NzDatePickerModule,
    DatepickerComponent,
    CommonModule,
    MultiselectComponent
  ],
  templateUrl: './invoice-filter.component.html',
  styleUrls: ['./invoice-filter.component.css']
})
export class InvoiceFilterComponent implements OnInit {
  @Input() filterFields: any[] = fields;
  @Input() includeBusinessStatus: any[] = [];
  @Input() processCodes: any[] = [];
  @Input() includeProcessingStatus: any[] = [];
  @Input() chequeNumbers: any[] = [];
  @Input() consumerList: any[] = [];
  @Input() export: boolean = false;
  @Input() pageId: string = '';
  @Output() searchEvent = new EventEmitter<any>();
  @Output() exportEvent = new EventEmitter<any>();
  statusList: LookupValueItem[] = [];
  processStatusList: LookupValueItem[] = [];
  filteredProcessStatusList: LookupValueItem[] = [];
  invoiceServiceCodes: LookupValueItem[] = [];

  invoiceSearchForm!: FormGroup;
  consumers = [
    { id: 'PRC-NY-10000802', name: 'Nikhil Malhotra' },
    { id: 'PRC-NY-10000801', name: 'Henderson Branch' },
    { id: 'PRC-NY-10000797', name: 'Renata Laugherane' },
    { id: 'PRC-NY-10000796', name: 'Torry Hunton' },
    { id: 'PRC-NY-10000804', name: 'Gwenni Malhotra' },
  ];

  providers = [
    { id: 'PRC-NY-10000802', name: 'Nikhil Malhotra' },
    { id: 'PRC-NY-10000801', name: 'Henderson Branch' },
    { id: 'PRC-NY-10000797', name: 'Renata Laugherane' },
    { id: 'PRC-NY-10000796', name: 'Torry Hunton' },
    { id: 'PRC-NY-10000804', name: 'Gwenni Malhotra' },
  ];

  filteredConsumers: any[] = [];
  filteredProviders: any[] = [];
  status = [
    { id: '1', name: 'Approved' },
    { id: '2', name: 'Rejected' },
    { id: '3', name: 'In Review' },
  ];

  // Regular vs Adjusted payroll selector. Only rendered when a page includes a
  // 'payrollType' field in its filterFields config (e.g. Invoice Payroll Processing).
  payrollTypeOptions = [
    { label: 'Regular', value: 'regular' },
    { label: 'Adjusted', value: 'adjust' },
  ];

  // Provider type options ({ code, name }); only loaded/rendered when a page
  // includes a 'providerType' field in its filterFields config.
  providerTypeList: any[] = [];

  loopback = [
    { label: '30 days', val: this.getDateBefore(30) },
    { label: '60 days', val: this.getDateBefore(60) },
    { label: '90 days', val: this.getDateBefore(90) },
    { label: '120 days', val: this.getDateBefore(120) },
    { label: '150 days', val: this.getDateBefore(150) },
    { label: '180 days', val: this.getDateBefore(180) },
    { label: '1 year', val: this.getDateBefore(365) },
    { label: '2 years', val: this.getDateBefore(730) },
    { label: '3 years', val: this.getDateBefore(1095) },
  ];
  showErrors = false;
  isSearched = false;


  tabId: string = '';
  programName!: string;
  payPeriod: any[] = [];
  servicePeriods: any[] = [];

  constructor(private fb: FormBuilder, private timesheetService: TimesheetService,
    private lookupService: LookupService, private dateTimeFormatter: DateTimeFormatterService,
    private userService: UserService
  ) { }

  ngOnInit(): void {
    const formFields = this.filterFields.reduce((acc, f) => {
      if (f.show) {
        if (f.field === 'Timeframe') {
          acc = { ...acc, [f.field]: [this.getDateBefore(30)] };
        }
        else{
          // `disabled: true` pins a filter to its default and greys it out — used by pages scoped
          // to a fixed status. Disabled controls drop out of form.value, so the emit paths below
          // read getRawValue().
          acc = { ...acc, [f.field]: [{ value: f.default ?? null, disabled: !!f.disabled }] };
        }
      }
      return acc;
    }, {});
    
    this.invoiceSearchForm = this.fb.group(formFields);

    const selectedProgram = this.userService.getSelectedProgram();
    this.programName = selectedProgram?.program_code ?? '';
    const businessStatusList = this.lookupService.getLookupValue('Invoice_Business_Status')
    this.statusList = this.includeBusinessStatus.length ? businessStatusList.filter((status: any) => {
      return this.includeBusinessStatus.includes(status.lkpValueCode);
    }) : businessStatusList;

    const processingStatusList = this.lookupService.getLookupValue('Invoice_Processing_Status');
    this.processStatusList = this.includeProcessingStatus.length ? processingStatusList.filter((status: any) => {
      return this.includeProcessingStatus.includes(status.lkpValueCode);
    }) : processingStatusList;
    // Statuses the Pended Invoices list returns (same as Pended Timesheets).
    this.filteredProcessStatusList = processingStatusList.filter(status => ['D', 'PE', 'RP', 'AC', 'SE'].includes(status.lkpValueCode));

    const invoiceServiceCodes = this.lookupService.getLookupValue('invoice_filter_serviceCode');
    // transform invoiceservicecodes, include one more property 'label' which is combination of lkpValueCode and lkpValueName
    invoiceServiceCodes.forEach((code : any) => {
      code.label = `${code.lkpValueCode} - ${code.lkpValueName}`;
    });

    this.invoiceServiceCodes = invoiceServiceCodes;

    const providerTypeConfiguration = this.filterFields.find(entry => entry.field === 'providerType' && entry.show);
    if (providerTypeConfiguration) {
      this.providerTypeList = this.lookupService.getProviderLookupValue() ?? [];
    }

    const payPeriodConfiguration = this.filterFields.find(entry => entry.field === 'payPeriod' && entry.show);
    if (payPeriodConfiguration) {
      this.getPayPeriod(payPeriodConfiguration.hideFuturePeriods);
    }

    const servicePeriodConfiguration = this.filterFields.find(entry => entry.field === 'servicePeriod' && entry.show);
    if (servicePeriodConfiguration) {
      this.getServicePeriod(servicePeriodConfiguration.hideFuturePeriods);
    }
  }

  getServicePeriod(hideFuturePeriods: boolean) {
    this.timesheetService
      .getServicePeriod(this.programName)
      .subscribe((data: any) => {
        const servicePeriodRecords = data.responsedata ?? [];
        if (hideFuturePeriods) {
          const today = new Date();
          const todayMidnight = new Date(today.getFullYear(), today.getMonth(), today.getDate());

          this.servicePeriods = servicePeriodRecords.filter((record: any) => {
            const startDate = new Date(record.workWeekStartDate);
            const startMidnight = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());

            return startMidnight <= todayMidnight;
          });
        } else {
          this.servicePeriods = servicePeriodRecords;
        }
      });
  }

  getDateBefore(days: number): string {
    const date = new Date();
    date.setDate(date.getDate() - days); // subtract days
    return date.toLocaleDateString('en-US'); // mm/dd/yyyy
  }

  onInput(e: Event, fieldName: string): void {
    const value = (e.target as HTMLInputElement).value;

    if (fieldName === 'consumer') {
      this.filteredConsumers = value ? this.consumers.filter(c => c.name.toLowerCase().includes(value.toLowerCase())) : [];
    } else if (fieldName === 'provider') {
      this.filteredProviders = value ? this.providers.filter(c => c.name.toLowerCase().includes(value.toLowerCase())) : [];
    }

  }

  search() {
    this.showErrors = false;
    this.isSearched = true;
    this.searchEvent.emit(this.invoiceSearchForm.getRawValue());
  }

  exportToExcel() {
    this.showErrors = false;
    this.exportEvent.emit(this.invoiceSearchForm.getRawValue());
  }

  onSearchChequeClick() {
    this.showErrors = false;
    if (this.invoiceSearchForm.get('consumerPplId')?.value && this.invoiceSearchForm.get('consumerPplId')?.value.trim() &&
      this.invoiceSearchForm.get('providerPplId')?.value && this.invoiceSearchForm.get('providerPplId')?.value.trim()) {
      this.searchEvent.emit({ ...this.invoiceSearchForm.getRawValue(), "chequeLookUp": true });
    } else {
      this.showErrors = true;
    }
  }

  disabledFutureDates = (current: Date): boolean => {
    const serviceDateConfiguration = this.filterFields?.find(entry => entry.field === 'serviceDate');
    if (serviceDateConfiguration?.hideFuturePeriods) {
      const today = new Date();
      return current.getTime() > today.getTime();
    }

    return false;
  };

  getPayPeriod(hideFuturePeriods: boolean) {
    this.timesheetService
      .getPayPeriod(this.programName)
      .subscribe((data: any) => {
        const payPeriodRecords = data.responsedata;
        if (hideFuturePeriods) {
          const today = new Date();
          const todayMidnight = new Date(today.getFullYear(), today.getMonth(), today.getDate());

          this.payPeriod = payPeriodRecords.filter((record: any) => {
            const startDate = new Date(record.payrollStartDate);
            const startMidnight = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());

            return startMidnight <= todayMidnight;
          });
        } else {
          this.payPeriod = payPeriodRecords;
        }
      });
  }
}
